import { useState, type FormEvent } from 'react';
import SocialButtons from './SocialButtons';
import PasswordRequirements from './PasswordRequirements';
import { brand } from '../config/brand';

interface Props {
  email: string;
  password: string;
  loading: boolean;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: (e: FormEvent) => void;
  onSwitchView: (view: 'login') => void;
}

export default function SignupForm({
  email,
  password,
  loading,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onSwitchView,
}: Props) {
  const [passwordFocused, setPasswordFocused] = useState(false);

  return (
    <div className="auth-form">
      <div>
        <h2>Create account</h2>
        <p className="auth-subtitle">
          Get started with <strong>{brand.name}</strong>
        </p>
      </div>
      <SocialButtons />
      <div className="auth-divider">
        <span>or</span>
      </div>
      <form onSubmit={onSubmit} className="auth-form">
        <div className="field">
          <label className="field-label" htmlFor="signup-email">
            Email
          </label>
          <input
            id="signup-email"
            className="input"
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            required
            autoComplete="email"
            placeholder="you@company.com"
          />
        </div>
        <div className="field">
          <label className="field-label" htmlFor="signup-password">
            Password
          </label>
          <input
            id="signup-password"
            className="input"
            type="password"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
            onFocus={() => setPasswordFocused(true)}
            onBlur={() => setPasswordFocused(false)}
            required
            autoComplete="new-password"
            placeholder="8+ chars, uppercase, digit"
            minLength={8}
          />
          <PasswordRequirements
            password={password}
            visible={passwordFocused || password.length > 0}
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Creating...' : 'Create Account'}
        </button>
        <div className="auth-links">
          <button type="button" className="link-btn" onClick={() => onSwitchView('login')}>
            Back to sign in
          </button>
        </div>
      </form>
    </div>
  );
}
